const SectionHeading = ({
  badge,
  title,
  highlight,
  description,
  center = true,
  theme = "light",
}) => {
  const isDark = theme === "dark";

  return (
    <div className={`${center ? "text-center" : ""} max-w-3xl mx-auto px-4`}>
      {badge && (
        <span
          className={`inline-block rounded-full px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 text-[10px] sm:text-xs md:text-sm font-semibold uppercase tracking-[2px] sm:tracking-[3px] transition-all duration-300 ${
            isDark
              ? "bg-white/10 text-pink-300 border border-white/10"
              : "bg-pink-100 text-[#b31159]"
          }`}
        >
          {badge}
        </span>
      )}

      <h2
        className={`mt-3 sm:mt-4 text-2xl sm:text-3xl md:text-4xl lg:text-[42px] font-bold leading-snug md:leading-tight tracking-tight transition-colors duration-300 ${
          isDark ? "text-white" : "text-slate-800"
        }`}
      >
        {title}{" "}
        {highlight && (
          <span className="bg-gradient-to-r from-pink-500 via-fuchsia-500 to-violet-600 bg-clip-text text-transparent">
            {highlight}
          </span>
        )}
      </h2>

      {description && (
        <p
          className={`mt-2 sm:mt-3 mb-5 sm:mb-6 max-w-2xl mx-auto text-sm sm:text-base md:text-lg leading-6 sm:leading-7 transition-colors duration-300 ${
            isDark ? "text-slate-300" : "text-slate-500"
          }`}
        >
          {description}
        </p>
      )}

      {/* Divider */}
      <div
        className={`relative mx-auto h-1 w-24 sm:w-32 md:w-40 overflow-hidden rounded-full ${
          isDark ? "bg-white/10" : "bg-pink-100"
        }`}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-pink-500 via-fuchsia-500 to-violet-600"></div>

        <div className="absolute top-1/2 -translate-y-1/2 animate-dot">
          <div className="h-2.5 w-2.5 sm:h-3 sm:w-3 rounded-full bg-white shadow-[0_0_12px_rgba(255,255,255,.8),0_0_25px_rgba(236,72,153,.9)]"></div>
        </div>
      </div>
    </div>
  );
};

export default SectionHeading;